import moment from "moment";

const localizeMoment = () => {
  moment.updateLocale("es", require("moment/locale/es"));
};

export default localizeMoment;
